import React from 'react';
import PropTypes from 'prop-types';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import { useConfigValue } from '../../../../../hooks/useConfigValue';
import { hashCodeOfWithFallback } from '../../../../../util/hash-code';
import { propTypes as i18nPropTypes } from '../../../../../hocs/intlEquipped';
import { paymentPropType } from '../../../../../types/subscription';

import Link from '../../../../Link';
import SubscriptionPaymentDetail from '../../SubscriptionPaymentDetail';

import DetailsSubHeader from '../DetailsSubHeader';

const ITunesDetailsContent = ({ payment, theme, i18n: { formatMessage } }) => {
    const { myPage } = useConfigValue();
    const explanationLinksHeader = myPage?.explanationLinks?.header;
    const explanationLinks = myPage?.explanationLinks?.iTunes || [];

    return (
        <>
            { payment.type && (
                <SubscriptionPaymentDetail
                    payment={ payment }
                    theme={ theme }
                    formatMessage={ formatMessage }
                />
            )}
            <div className={ theme.explanationText }>
                { formatMessage('subscription.sapiExplanationText.iTunes') }
            </div>
            { explanationLinks.length > 0 && (
                <>
                    <DetailsSubHeader text={ explanationLinksHeader } />
                    {explanationLinks.map(explanationLink => (
                        <div key={ hashCodeOfWithFallback(explanationLink.href) }>
                            <Link
                                href={ explanationLink.href }
                                theme={ theme }
                                className={ theme.explanationLink }
                                Icon={ OpenInNewIcon }
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {explanationLink.text}
                            </Link>
                        </div>
                    ))}
                </>
            ) }
        </>
    );
};

ITunesDetailsContent.propTypes = {
    payment: paymentPropType.isRequired,
    theme: PropTypes.shape({}),
    i18n: i18nPropTypes,
};

export default ITunesDetailsContent;
